import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon from "@insite/mobius/Icon";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SpecialMessageIcon from "@tCentro/Icons/SpecialMessageIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: NISProductSpecialMessageStyles;
    specialMessage?: string;
}

type Props = OwnProps;

export interface NISProductSpecialMessageStyles {
    specialMessage?: TypographyProps;
    specialMessageIcon?: InjectableCss;
}

export const nisProductSpecialMessageStyles: NISProductSpecialMessageStyles = {
    specialMessage: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
            text-transform: capitalize;
            color: ${COLORS.lightGreen};
            font-family: Roboto;
        `,
    },
    specialMessageIcon: {
        css: css`
            vertical-align: middle;
        `,
    },
};

const NISProductSpecialMessage: FC<Props> = ({ specialMessage }) => {
    return (
        <StyledWrapper>
            <StyledWrapper {...nisProductSpecialMessageStyles.specialMessage}>
                <Icon src={SpecialMessageIcon} {...nisProductSpecialMessageStyles.specialMessageIcon} />
                {specialMessage}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default NISProductSpecialMessage;
